/* SOFT SKILLS COURSES */
export const GET_SOFTSKILLS_USER_COURSES = "GET_SOFTSKILLS_USER_COURSES"
export const GET_SOFTSKILLS_USER_COURSES_SUCCESS =
  "GET_SOFTSKILLS_USER_COURSES_SUCCESS"
export const GET_SOFTSKILLS_USER_COURSES_ERROR =
  "GET_SOFTSKILLS_USER_COURSES_ERROR"
